export default {
	app: {
		brand_zh: '悠络客',
		brand_en: 'ULUCU',
	},
	common: {
		todo_module: '该模块尚未实现，开发中',
		loading: '加载中…',
		no_data: '暂无数据',
		select_store: '选择门店',
		show_raw: '查看原始响应',
		reload: '刷新',
		filter: '筛选',
		cancel: '取消',
		back: '返回',
	},
	group: {
		core: '核心',
		major: '主要',
		support: '业务支持',
		value_add: '增值',
	},
	tabbar: {
		monitor: '监控',
		home: '首页',
		store: '门店',
		application: '应用',
		incidents: '事件',
		analytics: '分析',
		operations: '运营',
		account: '账户',
		video: '视频',
		reports: '报表',
		workbench: '工作台',
		messages: '消息',
		profile: '我的',
		messages_title: '消息中心',
		reports_title: '顾客分析',
	},
	ops: {
		title: '运营',
		subtitle: '巡店、AI 巡检与设备协作',
		available: '可用功能',
		permission_required: '需开通或确认',
		empty: '暂无可用功能',
		view_status: '查看状态',
	},
	capability: {
		available_short: '当前区域可用',
		permission_required_short: '需后台开通权限',
		unknown_short: 'API 覆盖待确认',
		region_unavailable_short: '当前区域不可用',
		permission_required_desc: '当前账号无权使用该模块。海外原生提示：You do not have the right to this module.',
		unknown_desc: '该能力在 APAC/Mexico 的 API 覆盖还未完全确认，需要先做接口验证再开放给用户。',
		region_unavailable_desc: '该能力属于中国区能力，在当前 APAC/Mexico 部署中不应开放。',
		back_to_operations: '返回运营',
	},
	root: {
		monitor: {
			subtitle: '门店视频、设备状态与多画面巡看',
			store_count: '门店',
			online_devices: '在线设备',
			offline_devices: '离线设备',
			favorites: '收藏',
			tools: '监控工具',
			stores: '门店与通道',
			offline_action: '查看离线门店',
			offline_filter_active: '正在筛选离线',
			tool_store: '门店管理',
			tool_store_hint: '查看门店资料、分组与经营状态',
			tool_device: '设备状态',
			tool_device_hint: '检查设备在线、离线与通道状态',
			tool_multi_view: '多画面',
			tool_multi_view_hint: '先选择门店，再打开多通道巡看',
			tool_multi_view_empty: '暂无可巡看的门店',
			multi_view_select_store: '选择门店',
			multi_view_store_count: '{{online}}/{{total}} 在线',
			multi_view_no_online: '无在线通道',
		},
		analytics: {
			subtitle: '客流、会员、车流与经营洞察',
			visible_modules: '展示模块',
			primary_period: '主周期',
			trend_period: '趋势周期',
			currency: '币种',
			tools: '分析工具',
			insights: '洞察摘要',
		},
		incidents: {
			subtitle: '待处理事件、告警与门店消息',
			pending: '待处理事件',
			pending_hint: '需要运营跟进',
			today: '今日事件',
			today_hint: '今天全部事件',
			alerts: '告警消息',
			alerts_hint: '防损与异常提醒',
			visible_types: '消息类型',
			unread: '未读',
			loaded: '已加载',
			status: '状态',
			live: '实时',
			tools: '事件工具',
			workflow: '处理入口',
			status_overview: '事件状态',
			recent_messages: '最近消息',
			inbox: '事件收件箱',
			action_event: '处理事件',
			action_event_hint: '查看待处理、申诉与复核',
			action_alert: '查看告警',
			action_alert_hint: '定位异常门店与告警消息',
			action_message: '消息中心',
			action_message_hint: '查看全部通知与系统消息',
			refresh: '刷新事件概览',
			updated_at: '更新于 {{time}}',
			not_updated: '尚未更新',
			partial_data: '部分事件数据暂不可用',
			message_load_failed: '消息加载失败',
			message_empty: '当前分类暂无消息',
		},
		account: {
			subtitle: '组织、区域、语言与支持服务',
			region: '区域',
			language: '语言',
			recent_count: '最近观看',
			support_count: '支持入口',
			profile: '账户资料',
			preferences: '区域与语言',
			profile_hint: '姓名、手机、邮箱与头像',
			language_hint: '中文 / Español México',
			activity: '活动记录',
			support: '支持服务',
		},
	},
	wb: {
		evaluation: '门店考评',
		free_patrol: '自由巡检',
		self_inspect: '门店自检',
		timed_check: '定时点检',
		ai_patrol: 'AI 巡检',
		report_audit: '报告审核',
		workorder: '整改工单',
		reward: '奖惩中心',
		custom: '自定义',
		customize: '自定义',
		saved: '已保存',
		saved_local_only: '已保存到本地（云同步失败）',
		locked: '未开通',
		self_check: '门店自点检',
		cust_analysis: '顾客分析',
		heatmap: '热区分析',
		apparel: '服装分析',
		flow_alert: '客流预警',
		member_id: '会员识别',
		open_store: '开店筹建',
		announce: '公告',
		task: '任务',
		report_in: '报备',
		staff: '员工管理',
		cert: '证书管理',
		university: '悠学堂',
		huiting: '慧听',
		store_data: '门店数据',
		pic_detect: '画面检测',
		cat: {
			patrol: '巡店通',
			customer: '客流洞察',
			enterprise: '企业助手',
			other: '其他应用',
		},
		editor: {
			title: '管理应用',
			cancel: '取消',
			ok: '确定',
			hint: '拖动可调整应用位置',
			shown: '首页应用',
		},
	},
	store_video: {
		tab_video: '门店视频',
		tab_data: '门店数据',
		store_data_unavailable: '门店数据将单独复刻。本页只复刻门店视频列表。',
		organization: '组织',
		organization_all: '全部组织',
		organization_empty: '暂无组织数据',
		organization_failed: '组织筛选暂不可用：{{reason}}',
		organization_store_count: '{{count}} 家门店',
		filter: '筛选',
		search: '搜索',
		search_placeholder: '请输入门店名称或门店代码',
		favorite_only: '只看收藏',
		summary_one: '共 {{count}} 家门店，在线率 {{rate}}',
		summary: '共 {{count}} 家门店，在线率 {{rate}}',
		offline_count: '离线 {{count}}',
		online_count: '在线 {{count}}',
		total_count: '总计 {{count}}',
		created_at: '门店创建时间',
		open_multi_view: '打开多画面',
		sort_title: '排序',
		sort_default: '默认',
		sort_default_ranking: '默认排名',
		sort_high_to_low: '从高到低',
		sort_low_to_high: '从低到高',
		sort_offline: '离线优先',
		sort_create: '创建时间',
		sort_name: '门店名称',
		favorite_store_video: '收藏门店视频',
		favorite_store_data: '收藏门店数据',
		no_collection: '暂无收藏',
		filter_data: '数据',
		filter_time: '时间',
		metric_entry_number: '进店人数',
		metric_total_number: '总人数',
		metric_total_sales: '总销售额',
		metric_ecr: '成交率',
		metric_events: '事件',
		metric_turnover_rate: '周转率',
		time_today: '今天',
		time_yesterday: '昨天',
		time_week: '本周',
		time_seven: '近 7 天',
		time_month: '本月',
		time_thirty: '近 30 天',
		calling_store_manager: '正在呼叫店长',
	},
	settings: {
		account: '账号与语言',
		app: '应用信息',
		storage: '本地存储',
		support: '支持服务',
		runtime: '运行环境',
		runtime_app: '手机 App',
		runtime_web: '浏览器 Web',
		version: '版本',
		version_hint: '当前前端包版本',
		clear_recent: '清空最近观看',
		clear_recent_hint: '当前 {{count}} 条本地观看记录',
		clear_recent_success: '最近观看已清空',
		feedback_hint: '提交投诉建议',
		hotline_hint: '查看当前地区支持方式',
		logout: '退出登录',
	},
	mtab: {
		video: {
			brand_full: '上海悠络客电子科技股份有限公司',
			search_placeholder: '请输入门店名称或门店代码',
			filter: '筛选',
			tab_all: '全部',
			tab_fav: '收藏',
			summary_one: '共 {{count}} 家门店，设备总在线率: {{rate}}',
			summary: '共 {{count}} 家门店，设备总在线率: {{rate}}',
			offline_count_one: '{{n}} 台设备离线',
			offline_count: '{{n}} 台设备离线',
			device_online: '在线',
			device_offline: '离线',
			all_online: '全部在线',
			no_device: '暂无设备',
			view_all: '查看全部',
		},
		msg: {
			system: '系统消息',
			event: '事件消息',
			examine: '考评消息',
			critical: '重点人员到店',
			empty: '近 2 天暂无消息～',
		},
		profile: {
			guest: '未登录',
			subtitle: '客户演示账号',
			album: '我的相册',
			recent: '最近观看',
			repair: '在线报修',
			repair_log: '报修记录',
			hotline: '维修热线',
			feedback: '投诉建议',
			changelog: '更新日志',
			settings: '设置',
			settings_hint: '语言、版本、缓存与退出',
			recent_empty: '暂无观看记录',
			recent_view_all: '查看全部',
			edit_profile: '个人资料',
			edit_personal_data: '编辑个人资料',
			name: '名字',
			mobile: '手机',
			mobile_phone: '手机号码',
			email: '邮箱',
			email_address: '邮箱地址',
			email_placeholder: '请输入内容',
			edit_avatar: '编辑头像',
			save: '保存',
			save_success: '已保存',
			save_unavailable: '保存功能暂未开放',
			online: '在线',
			offline: '离线',
			hotline_label: '客户服务热线',
			call: '拨打',
			feedback_placeholder: '请输入您的建议或意见…',
			feedback_submit: '提交',
			feedback_required: '请填写内容',
			feedback_success: '感谢您的反馈',
			changelog_empty: '暂无更新日志',
		},
		rep: {
			pos_input: 'POS 录入',
			portrait: '顾客画像',
			precise: '精准客流分析',
			batch: '批次客流',
			realtime: '实时客流',
			consume: '消费分析',
			distribution: '客流分布',
			funnel: '转化漏斗',
			duration: '停留时长分析',
			rank: '门店排行',
			store_filter: '当前 {{count}} 个门店',
			overview: '数据总览',
			mom: '环比',
			yoy: '同比',
			compare_range: '环比日期',
			pass_count: '过店客流',
			enter_count: '进店客流',
			enter_conv: '进店转化率',
			try_count: '试穿客流',
			try_conv: '试穿转化率',
			member_count: '到店会员',
			stay_duration: '人均停留时长(分)',
			deal_conv: '成交转化率',
			leave_count: '离店客流',
			invoice_count: '交易笔数',
			amount: '销售额',
			commodity_count: '商品数',
			avg_enter: '日均进店',
			hour: '时',
			day: '天',
			flow_trend: '客流总体趋势',
			daily_avg: '日均客流',
			peak: '客流峰值',
			valley: '客流谷值',
		},
	},
	player: {
		hd: '高清',
		sd: '标清',
		fill: '满屏',
		fit: '适应',
		live: '实时',
		playback: '回放',
		all: '全部',
		view_legend: '查看图例',
		no_device: '请选择设备',
		no_stream: '尚无视频流',
		no_history: '当日无录像',
		no_record_at_time: '该时刻无录像',
		playback_started: '回放开始',
		history_segment_count: '{{count}} 段录像',
		screenshot_done: '截图已下载',
		fn_screenshot: '截图',
		fn_intercom: '语音对讲',
		fn_record: '录像',
		fn_event: '创建事件',
		fn_ptz: '云台操控',
		fn_pos: '小票查询',
		fn_record_stop: '停止录像',
		recording_started: '正在录像…',
		recording_saved: '录像已保存',
		cap_unsupported: '该设备不支持此功能',
		share: '分享',
		video_init_failed: '视频初始化失败...',
	},
	ptz: {
		no_permission: '当前账号无云台控制权限，请联系管理员在 ulucu 后台开通',
	},
	rename: {
		title: '修改通道别名',
		placeholder: '请输入新别名',
		success: '已修改',
		failed: '修改失败',
	},
	channel: {
		select: '选择通道',
		count: '{{count}} 通道',
	},
	store_detail: {
		tab_devices: '设备列表',
		tab_overview: '数据概况',
		copy: '复制',
		copied: '已复制',
		copy_failed: '复制失败',
		created_at: '门店创建时间',
		devices_all: '全部设备',
		devices_online: '在线设备',
		devices_offline: '离线设备',
		cat_all: '全部设备',
		cat_camera: '摄像头',
		cat_audio: '语音设备',
		my_nvr_devices: '我的 nvr 设备',
		multi_view: '多画面预览',
		open_video: '打开视频',
		more: '更多',
		status_online: '在线',
		status_offline: '离线',
		offline_hint: '设备离线，暂不可播放',
		offline_unplayable: '设备离线，暂不可播放',
		call_owner: '呼叫店长',
		no_phone: '该门店无电话',
		repair_log: '报修记录',
		service_hotline: '维修热线',
		delete_store: '删除门店',
		confirm_delete: '确认删除门店？',
		confirm_delete_ok: '删除',
		deleted: '已删除',
		delete_failed: '删除失败',
	},
	repair: {
		title: '在线报修',
		store: '门店选择',
		contact: '联系人',
		contact_phone: '联系电话',
		store_phone: '门店电话',
		describe: '故障描述',
		optional: '选填',
		add_images: '添加图片',
		images_tip: '请上传能说明故障问题的图片，以便我们及时排查和解决问题',
		tip: '为保障反馈的问题及时解决，建议报修对应故障方案后，再进行平台报修',
		submit: '提交',
		contact_required: '请输入联系人',
		phone_required: '请输入联系电话',
		describe_required: '请输入故障描述',
		success: '报修成功',
		failed: '报修失败',
		over_limit: '当前门店待处理报修已达上限，请处理已有报修记录后再提交新的报修。',
		history: '报修记录',
	},
	hotline: {
		cn_desc: '中国区账号可直接拨打客户服务热线。',
		local_label: '本地支持',
		local_value: 'APAC / México',
		local_desc: '墨西哥与 APAC 用户不使用中国 400 热线，请通过反馈入口或本地客户经理处理支持请求。',
		feedback_action: '提交支持请求',
	},
	inspect: {
		status: '状态',
		overdue: '已超期',
		progress: '进度',
	},
	patrol: {
		total_plans: '巡店计划总数',
		completed: '已完成',
		overdue: '已超期',
		completion_rate: '巡店完成率',
	},
	message: {
		unread_by_category: '按分类未读数',
		unread: '未读',
		recent: '最近消息',
		cat_all: '全部',
		cat_event: '事件',
		cat_alarm: '报警',
		cat_examine: '点检',
		cat_system: '系统',
		// 后端 unread_count items.title 完整分类（apac 实测 av=4 返回 20 类）
		cat_share: '分享',
		cat_face: '人脸识别',
		cat_human_alarm: '人形报警',
		cat_shop_inspection: '巡店通',
		cat_detachment_detection: '脱岗侦测',
		cat_spot_inspection: '点检任务',
		cat_black_list: '黑名单',
		cat_youxun_moveai: '悠巡 移动 AI',
		cat_youxun_picai: '悠巡 图片 AI',
		cat_pos_trade: 'POS 交易',
		cat_youqin: '悠勤考勤',
		cat_face_mask: '口罩识别',
		cat_data_warning: '数据预警',
		cat_take_place: '事件触发',
		cat_youxun_advancedai: '悠巡 高级 AI',
		cat_youxun_paidui: '悠巡 排队',
		cat_shelf_analysis: '货架分析',
	},
	alert: {
		total: '报警总数',
		pending: '待处理',
		handled: '已处理',
	},
	incident_domain: {
		title: '事件处理工作台',
		subtitle: '事件、报警与消息统一处理',
		partial_data: '部分事件数据暂不可用',
		alert_unread: '未读报警',
		message_unread: '未读消息',
		status_overview: '事件状态总览',
		alert_workbench: '报警处置',
		alert_note: '当前已接入报警统计',
		alert_note_desc: '报警明细需要事件类型字典后开放；现阶段请从事件状态和报警消息先定位待处理风险。',
		message_workbench: '消息处理',
		no_messages: '当前分类暂无消息',
		event_message_hint: '事件消息还有 {{count}} 条未读，可切换到消息中心处理。',
	},
	store: {
		all_stores: '全部门店',
		groups: '门店组',
		total: '门店总数',
		online: '营业中',
		with_device: '已装设备',
		has_device: '有设备',
		stores_in_group: '家门店',
	},
	heatmap: {
		todo_visualization: '热力图可视化待补',
		todo_desc: '原始数据已拿到（见下方）。后续将用 ECharts heatmap 渲染。',
	},
	msg: {
		order_title: '消息类型排序',
		save: '保存',
		saved: '已保存',
		available: '可添加的消息类型',
		no_more: '— 没有更多了 —',
		row_label: '{{label}}，第 {{position}} 项，共 {{total}} 项',
		remove_label: '移除「{{label}}」',
		add_label: '添加「{{label}}」',
		move_up_label: '上移「{{label}}」',
		move_down_label: '下移「{{label}}」',
		unread_card_label: '未读消息：{{title}}',
		status: { unread: '未读' },
		kp: {
			arrive_time: '到店时间',
			store: '所到门店',
			name: '姓名',
			sex: '性别',
			male: '男',
			female: '女',
			record: '到店记录',
			arrive_n_times: '到店{{n}}次',
		},
		pos: {
			fallback: '交易消息',
			type_1: '销售',
			type_2: '退款',
			type_3: '充值',
			type_4: '报损',
			type_5: '抹零',
			type_6: 'AI 异常',
			type_7: '修正',
			type_8: '退单退货',
			type_9: '反结账',
			type_10: '打折单',
			type_11: '外卖退单',
			type_12: '拒绝订单',
			type_13: '异常取消',
			type_14: '异常退单',
			type_15: '免单',
		},
	},
	msg_t: {
		system: '系统消息',
		event: '事件消息',
		examine: '考评消息',
		key_person: '重点人员到店',
		blacklist: '黑名单告警',
		xundian: '巡店消息',
		tuogang: '脱岗消息',
		pic_ai: '图片AI检测',
		move_ai: '视频AI检测',
		face_mask: '未戴口罩提醒',
		data_warn: '数据预警',
		cert: '证书管理消息',
		youschool: '悠学堂',
		store_build: '开店筹建',
		image_exception: '画面异常检测',
		alarm: '告警',
		human_alarm: '人形告警',
		face: '人脸识别',
		ai_tag_video: 'AI 视频',
		pos_trade: 'POS 交易',
		dianjian: '点检消息',
	},
	eval: {
		search_ph: '搜索任务',
		expired_tasks: '过期任务',
		no_active: '暂无进行中的任务',
		no_expired: '暂无过期任务',
		valid_time: '有效时间',
		to: '至',
		cycle: '任务周期',
		frequency: '任务频次',
		times: '次',
		eval_stores: '考评门店',
		done_stores: '已考评店',
		unit_store: '家',
		unit_copy: '份',
		progress: '任务进度',
		submit_count: '提交报告',
		remote_eval: '远程考评',
		onsite_eval: '现场考评',
		view_report: '查看报告',
		detail_title: '查看任务',
		template: '考评模版',
		evaluators: '考评人',
		recent_reports: '最近已提交报告',
	},
	rp: {
		tab_records: '奖惩记录',
		tab_levels: '奖惩级别',
		all_rp: '全部奖惩',
		reward: '奖励',
		penalty: '惩罚',
		last_7d: '近 7 天',
		last_30d: '近 30 天',
		last_90d: '近三个月',
		sort_by_create: '按创建时间',
		add: '新增',
		edit: '编辑',
		delete: '删除',
		confirm_delete: '确认删除该级别？',
		deleted: '已删除',
		delete_failed: '删除失败',
		edit_title: '编辑级别',
		add_title: '新增级别',
		save: '保存',
		saved: '已保存',
		save_failed: '保存失败',
		type: '类型',
		level_name: '级别名称',
		level_name_ph: '请输入级别名称',
		amount: '奖惩金额',
		amount_ph: '请输入金额',
		usage: '使用情况',
		usage_ph: '请输入使用情况说明',
		title_required: '请输入级别名称',
		amount_required: '请输入有效金额',
	},
	hot: {
		select_store: '选择门店：',
		date: '日期：',
		pick_store: '请先选择门店',
		no_device: '该门店无热区设备',
		not_configured: '该设备暂未配置热区分析（无区域定义）',
		filter_areas: '筛选区域',
		show_all: '全部显示',
		hide_all: '全部隐藏',
		stay_label: '停留时间：',
		seconds: '{{n}} 秒',
		keliu: '客流人次',
		stop: '驻足人次',
		stop_rate: '驻足率',
		avg_stay: '平均停留时长',
	},
	traffic: {
		total_vehicles: '车辆总数',
		avg_plate: '平均车牌识别',
		hourly_trend: '车流时段趋势',
	},
	leavepost: {
		no_records: '该日无脱岗记录',
		duration: '脱岗时长',
	},
	auth: {
		login_title: '账号登录',
		account: '账号',
		account_required: '请输入账号',
		password: '密码',
		password_required: '请输入密码',
		login: '登 录',
		login_success: '登录成功',
		login_failed: '登录失败',
		session_elsewhere: '检测到你的账号已在别处登录，请重新登录。',
		remember_account: '记住账号',
		logout: '退出',
		logged_in_as: '当前账号',
		tip_internal_dev: '当前为开发联调模式，调用 ulucu 内部 API（待开放平台凭证就绪后切换）',
	},
	home: {
		welcome: '欢迎使用 Ulucu',
		intro: '门店管理客户端 · 多语言版本（中 / 英 / 西 / 阿）',
		store_count: '共 {{count}} 家门店',
		has_device: '有设备',
	},
	dashboard: {
		online_rate: '设备在线率',
		device_status: '设备状态分布',
	},
	device: {
		total: '设备总数',
		online: '在线',
		offline: '离线',
		channels: '通道',
		off_time: '离线时间',
		select_device: '选择设备',
	},
	daterange: {
		today: '今天',
		'7d': '近 7 天',
		'30d': '近 30 天',
	},
	cust: {
		tab_portrait: '顾客画像',
		tab_precise:  '精准客流分析',
		tab_batch:    '批次客流',
		tab_realtime: '实时客流',
		tab_consume:  '消费分析',
		tab_device:   '设备分析',
		filter: '筛选',
		current_n_stores: '当前 {{n}} 个门店',
		overview: '数据总览',
		portrait_total: '顾客画像总数',
		most_portrait: '多数到店顾客画像-精准',
		unit_person: '人',
		member_ratio: '会员占比',
		gender_ratio: '性别占比',
		age_ratio: '年龄占比',
		age_x_gender: '年龄与性别分析',
		age_x_identity: '年龄与身份分析',
		member: '会员',
		non_member: '非会员',
		male: '男',
		female: '女',
		precise_wip_title: '精准客流分析',
		precise_wip_desc: '数据总览 + 客流分布 + 转化漏斗 + 停留时长 + 门店排行（待补完）',
		mom: '环比',
		yoy: '同比',
		sub_flow: '客流分布',
		sub_funnel: '转化漏斗',
		sub_stay: '停留时长分析',
		sub_rank: '门店排行',
		gran_hour: '时',
		gran_day: '天',
		flow_trend: '客流总体趋势',
		kpi: {
			pass: '过店客流',
			enter: '进店客流',
			enter_rate: '进店转化率',
			try: '试穿客流',
			try_rate: '试穿转化率',
			member: '到店会员',
			stay_avg: '人均停留时长 (分)',
			deal_rate: '成交转化率',
			bind_device: '请绑定离店设备',
			daily_avg: '日均客流',
			peak: '客流峰值 ({{date}})',
			valley: '客流谷值 ({{date}})',
		},
	},
	customer: {
		title: '客流分析',
		date: '日期',
		pass_count: '过店客流',
		enter_count: '进店客流',
		unit: '人',
		raw_response: '原始响应',
		hourly_trend: '客流时段趋势',
	},
	member: {
		overview: '概览',
		customer_list: '顾客列表',
		total: '老顾客总数',
		new_count: '新顾客',
		return_count: '回头客',
		visit_count: '到店 {{count}} 次',
		last_visit: '最近到店',
		start_from: '起始日期',
		anonymous: '匿名顾客',
	},
	event: {
		range: '时间范围',
		total: '共 {{count}} 条',
	},
	event_count: {
		all: '全部事件',
		wait: '待处理',
		wait_handle: '需处理',
		destroy: '已撤销',
		my: '我的事件',
		my_appeal: '我的申诉',
		appeal_audit: '申诉审核',
		recheck: '复核',
	},
	live: {
		online_devices: '设备列表',
		no_online: '该门店暂无设备',
		play_live: '立即直播',
		get_play_token: '获取播放凭证',
		play_token_for: '播放凭证 · ',
		cloud_storage: '云存储',
		web_limitation: 'Web 实时视频说明',
		web_limitation_desc: '现 app 走 AYClient_SDK 私有协议；新方案走开放平台 auth.weburl 接口拿 HFLV/HLS URL（浏览器能播，1-2s 延迟）。下方 PoC 验证 flv.js 在你浏览器的兼容性，真接口需开放平台凭证。',
		token_only_note: '已拿到 play_token（内部 API 路径，给 native SDK 用）。开放平台 auth.weburl 路径需要 appID/Secret 凭证。',
		poc_title: 'HFLV 浏览器能力 PoC',
		poc_intro: '验证 flv.js + 浏览器能播 HFLV 协议',
		poc_intro_desc: '用公开测试流验证浏览器/Capacitor WebView 兼容性。flv.js 通过则等 ulucu 开放平台 appID/Secret 拿到后即可接真接口；不通则降级到 hls.js（3-5s 延迟）。',
		test_stream: '测试流',
		play: '播放',
		stop: '停止',
		reload: '重载',
		logs: '日志',
		missing_sn: '设备缺少 SN，无法播放',
	},
	scan: {
		browser_supported: '浏览器扫码能力可用',
		browser_unsupported: '当前浏览器不支持扫码',
		browser_supported_desc: 'Web 端可调用浏览器 BarcodeDetector；移动 App 会接入原生相机扫码。',
		browser_unsupported_desc: '请在支持相机扫码的移动 App 或兼容浏览器中使用。',
		capacitor_plan: 'iOS / Android 版本将使用原生扫码能力；当前 Web 端仅展示能力状态。',
		start_scan: '开始扫码',
	},
	modules: {
		dashboard: '首页',
		device: '设备',
		store: '门店',
		live: '实时视频',
		event: '事件中心',
		alert: '报警',
		inspect: '巡检',
		patrol: '巡店',
		leavepost: '脱岗',
		customer: '客流分析',
		traffic: '车流统计',
		heatmap: '热区分析',
		pos: '收银叠加',
		scan: '扫码',
		auth: '登录',
		member: '会员管理',
		evaluation: '评估考核',
		wechatvip: '企微VIP',
		figurewarning: '人形报警',
		university: '悠络客大学',
		staff: '员工管理',
		guard: '值守',
		message: '消息中心',
		rewardpunish: '奖惩',
		smartlistening: '智能听店',
		cloudstorage: '云存储',
		phonelive: '手机直播',
		sharedevice: '设备共享',
		datawarn: '数据预警',
		aipatrol: 'AI 巡检',
		reportaudit: '报告审核',
	},
	reportaudit: {
		title: '报告审核',
		tab: { audit: '审核管理', self: '自检管理' },
		filter: { store: '选择门店', date: '选择日期', status: '报告状态', template: '模板筛选' },
		status: { pending: '待审核', passed: '已通过', rejected: '未通过' },
	},
	changelog: {
		unread: '未读',
		load_more: '加载更多',
		no_more: '— 没有更多了 —',
	},
	album: {
		empty: '暂无截图',
		local: '本地截图',
		edit: '编辑',
		delete: '删除',
		deleted: '已删除',
		delete_failed: '删除失败',
		select_first: '请先选择截图',
		selected_n: '已选 {{n}} 张',
		confirm_delete: '确认删除选中的 {{n}} 张截图？',
		load_more: '加载更多',
		no_more: '— 没有更多了 —',
	},
	aipatrol: {
		title: 'AI 巡检',
		banner_title: 'AI 智能巡检',
		banner_subtitle: '7×24 自动识别异常，告别人工巡检',
		unnamed_model: '未命名模型',
		sec: { pic: '图片 AI 检测', video: '视频 AI 检测', other: '其他' },
		app: {
			datacenter: '数据中心',
			stats: '统计',
			report: '巡店报告',
			leavepost: '脱岗检测',
			gallery: '图片库',
			alert: '报警',
		},
		dc: {
			title: '数据中心',
			fav: '收藏夹',
			last7d: '近 7 天',
			all_stores: '全部门店',
			all_models: '全部模型',
			load_more: '点击或上拉加载更多',
			no_more: '— 没有更多了 —',
		},
		kpi: { stores: '开通门店数', devices: '开通设备数' },
		alarm: {
			title_yesterday: '昨日报警统计',
			count_label: '报警次数',
			load_more: '加载更多',
			latest: '最新报警统计',
		},
		stats: {
			title: '统计',
			last7d: '近七天',
			all_tasks: '全部任务',
			all_stores: '全部门店',
			all_users: '全部巡查人',
			violation_total: '总违规数',
			violation_type_count: '违规类型数',
			store_total: '选择门店总数',
			patroller_count: '总巡查人数',
			report_submit_count: '已提交报告数',
			trend: '门店整体趋势',
			dim_day: '日',
			dim_month: '月',
			rank: '违规项排名',
			view_more: '查看更多',
			col_item: '违规项名称',
			col_count: '违规数',
			col_stores: '违规门店数',
		},
	},
	rep: {
		title: '统计报表',
		dash: '至',
		last_7d: '近 7 天',
		today: '今日',
		no_content: '暂无内容',
		unit: { person: '人', percent: '%', yuan: '元' },
		cust: {
			title: '顾客分析',
			this_month: '本月',
			gdrs: '过店客流',
			jdkl: '进店客流',
			jzkl: '精准进店客流',
			jdzhl: '进店转化率',
			xsze: '销售总额',
		},
		youxun: {
			title: '悠巡',
			alarm_count: '报警统计',
			most_store: '报警最多门店',
			times: '次',
			none: '暂无',
		},
		xdt: {
			title: '巡店通',
			unit: '份',
			examine_submit: '提交考评',
			examine_waiting: '待审核报告数',
			examine_today: '今日考评任务',
			inspect_submit: '提交自检',
			inspect_waiting: '自检待审核',
			inspect_today: '今日自检任务',
			dj_handled: '点检已处理',
			dj_waiting: '点检待处理',
			dj_expired: '逾期未检',
		},
		event: {
			title: '事件统计',
			total: '事件总数',
			pending: '待处理事件数',
			key: '重点事件类型',
			unit: '件',
			none: '暂无',
		},
		editor: {
			btn: '排序与添加',
			title: '动态排序与添加',
			cancel: '取消',
			ok: '确定',
			advanced: '高级设置',
			shown: '动态页展示的模块',
			available: '可添加的模块',
		},
		advanced: {
			title: '悠巡 高级设置',
			search_ph: '搜索 AI 模型名称或 ID',
			counter: '已订阅 {{picked}} / 全部 {{total}}',
			saved: '订阅已保存',
			save_failed: '保存失败',
		},
	},
	mselect: {
		title: '视频播放筛选',
		search_ph: '输入设备名称',
		counter: '在线设备 {{online}}，已选择 {{picked}} 个',
		no_online: '该门店无在线设备',
		watch: '观看视频',
	},
	vfilter: {
		title: '筛选',
		device: '门店设备',
		has_dev: '有设备',
		no_dev: '无设备',
		status: '设备状态',
		online: '在线',
		offline: '离线',
		fav_status: '收藏状态',
		faved: '已收藏',
		unfaved: '未收藏',
		sort: '门店排序',
		sort_create: '按创建时间排序',
		sort_name: '按名称 A-Z 排序',
		reset: '重置',
		ok: '确定',
	},
	sov: {
		compare: '环比',
		rank_title: '该门店数据排行',
		b_avg: '企业平均',
		exceed: '超过 {{pct}}% 的门店',
		avg: '均值',
		settings_title: '门店数据设置',
		selected_data: '已选数据',
		selected_hint: '按住拖动调整顺序',
		done: '完成',
		saved: '已保存',
		save_failed: '保存失败',
		cat: {
			business: '营业数据',
			traffic: '客流数据',
			event: '管理数据',
		},
		p: {
			hour: '时',
			day: '天',
			week: '周',
			month: '月',
			quarter: '季',
		},
		t: {
			jzkl: '精准进店客流',
			gdrs: '过店客流',
			gdrs_f: '过店客流(F)',
			jdzhl: '进店转化率',
			xfds: '订单数',
			xsze: '销售总额',
			cjl: '成交转化率',
			sjzs: '事件总数',
			dclsjs: '待处理事件数',
			zkl: '总客流',
			jtlsc: '人均停留时长',
			kdj: '客单价',
			ldl: '连带率',
		},
	},
	native: {
		common: {
			all: '全部',
			clear: '清空',
			date: '日期',
			phone: '电话',
			remove_picture: '移除图片',
			submit: '提交',
			view_all: '查看全部',
			back: '返回',
			cancel: '取消',
			complete: '完成',
			confirm: '确认',
			copy: '复制',
			default: '默认',
			details: '详情',
			edit: '编辑',
			filter: '筛选',
			from_high_to_low: '从高到低',
			level: '等级',
			no_content: '暂无内容',
			no_data: '暂无数据',
			online: '在线',
			offline: '离线',
			operation_failed: '操作失败',
			organization: '组织',
			people: '人',
			pcs: '个',
			picture: '图片',
			refresh: '刷新',
			reset: '重置',
			save: '保存',
			search: '搜索',
			search_by_store_name: '按门店名称搜索',
			search_history: '搜索历史',
			store: '门店',
			video: '视频',
			all_stores: '全部门店',
			all_status: '全部状态',
			all_tasks: '全部任务',
			all_executors: '全部执行人',
		},
		settings: {
			title: '设置',
			modify_password: '修改密码',
			language_setting: '语言设置',
			clear_cache: '清除缓存',
			clear_cache_confirm: '确认清除缓存？',
			about_us: '关于我们',
			logout: '退出登录',
			old_password: '旧密码',
			new_password: '新密码',
			confirm_password: '确认密码',
		},
		profile: {
			my_album: '我的相册',
			watch_history: '观看历史',
			online_repair: '在线报修',
			repair_record: '报修记录',
			setting: '设置',
		},
		home: {
			title: '首页',
			latest_news: '最新消息',
			assessment: '考核',
			today: '今天',
			assessment_empty: '暂无内容',
			submitted: '提交考核',
			waiting_approve: '待审批',
			event: '事件',
			recent_7_days: '近 7 天',
			events: '事件',
			pending_events: '待处理事件',
			key_type: '重点事件类型',
			ranking: '排序与显示',
			organization: '组织',
			message: '消息中心',
			system_message: '系统消息',
			event_message: '事件消息',
			evaluation_message: '考核消息',
			store_inspection_message: '门店巡检消息',
			no_new_message: '暂无新消息',
			new_message: '新消息',
			no_latest_news: '暂无最新消息',
			last_update: '最后更新：',
			no_data_last_2_days: '近 2 天暂无数据~',
			management: '管理',
			statistics: '统计',
			report: '报告',
			my_assessment: '我的考核',
			audits: '审核',
			draft_box: '草稿箱',
			report_status: '报告状态',
			template: '模板',
			pending: '待处理',
			to_be_accepted: '待受理',
			processed: '已处理',
			expired: '已过期',
			deleted: '已删除',
			total_events: '事件总数',
			event_types: '事件类型',
			message_content_aria: '消息内容',
			message_aria: '消息',
			create_event: '创建事件',
			submit: '提交',
			select_store: '选择门店',
			please_choose_store: '请选择门店',
			please_choose_event_type: '请选择事件类型',
			event_scoring: '事件评分',
			priority: '优先级',
			assign_to: '指派给',
			follower: '关注人',
			remarks_placeholder: '备注 最多 3000 字',
			add_3_pictures: '最多添加 3 张图片',
			confirm: '确认',
			select_all: '全选',
			store_name: '门店名称',
			name: '名称',
			please_input_key_words: '请输入关键词',
			please_input_key_words_title: '请输入关键词',
			choose_store_required: '请选择门店',
			choose_event_type_required: '请选择事件类型',
			priority_source_pending: '优先级数据未就绪',
			scoring_required: '请选择事件评分',
			property_required: '请选择评分项',
			choose_assignor_required: '请选择指派人',
			picture_required: '请先选择或补充图片',
			event_created: '创建成功',
			choose_store_first: '请先选择门店',
			please_select_assignor: '请选择指派人',
			please_select_follower: '请选择关注人',
			select_assignor: '选择指派人',
		},
		application: {
			title: '应用',
			display_title: '排序与显示',
			display_subtitle: '应用页面显示模块',
			fixed: '固定',
			saved: '应用显示已保存',
			reset_done: '已恢复默认排序',
			last_visible: '至少保留一个应用可见',
			move_up: '上移',
			move_down: '下移',
			show: '显示',
			hide: '隐藏',
			function_intro: '功能介绍',
			permission_denied: '您没有此模块的使用权限。',
			groups: {
				store: '门店数字化',
				standard: '标准化管理',
				marketing: '智慧营销',
				data: '数据中心',
			},
			items: {
				customer_flow_analysis: '客流分析',
				traffic_flow: '车流统计',
				heat_map: '热力图',
				event: '事件',
				shake_inspection: '摇一摇巡检',
				off_duty_patro: '离岗巡检',
				timed_inspection: '定时巡检',
				timed_snapshot_inspection: '定时截图巡检',
				assessment: '考核',
				qr_code_scan_superposition: '二维码扫码叠加',
				intelligent_attendance: '智能考勤',
				reward_punish: '奖惩',
				smart_listening: '智能听音',
				shopping_guide: '导购',
				intelligent_classroom: '智能课堂',
				customer_flow_alert: '客流预警',
				ranking_display: '排序与显示',
				phone_live: '手机直播',
				smart_marketing: '智慧营销',
				data_center: '数据中心',
				cloud_storage: '云存储',
			},
		},
		store: {
			device_list: '设备列表',
			data: '数据',
			access_camera: '进入摄像机',
			repair_record: '报修记录',
			store_creation_time: '门店创建时间',
			camera_setting: '摄像机设置',
			camera_name: '摄像机名称',
			cloud_storage: '云存储',
			local_storage: '本地存储',
			connect_other_wifi: '连接其它 Wi-Fi',
			no_longer_use: '不再使用',
			connect_camera_to_store: '将摄像机连接到门店',
			compared_previous: '较上一周期',
			events: '事件',
			events_to_be_processed: '待处理事件',
			data_ranking: '门店数据排名',
			store_data_setting: '门店数据设置',
			data_selected_hint: '已选数据（长按拖动调整顺序）',
			manage_data: '管理数据',
			max_metrics: '最多选择 {{count}} 个指标',
			keep_one_metric: '请至少保留一个指标',
			chart_visibility: '图表显示设置',
			average: '均值',
			compared_previous_range: '（较上一周期{{range}}）',
			ranking_detail_with_unit: '企业平均 {{average}}{{unit}}，门店超越 {{exceed}}%',
			period_hour: '小时',
			period_day: '天',
			period_week: '周',
			period_month: '月',
			period_quarter: '季度',
			full_storage: '全量存储',
			mobile_detection_storage: '移动侦测存储',
			set_storage_schedule: '设置存储计划',
			entry_number: '进店人数',
			device_layout_preview: '预览布局',
			device_layout_list: '列表布局',
			device_is_offline: '设备已离线',
			offline_time: '离线时间',
			offline_duration: '离线时长',
			setting_unavailable: '该设置暂不支持在 Web 使用。',
			pieces: '{{count}} 个',
			ranking_detail: '企业平均 {{average}} 个，超越 {{exceed}} 门店',
			cloud_storage_banner_auto_detect: '自动检测，云端存储',
			cloud_storage_banner_look_back: '随时回看',
			cloud_storage_banner_encryption: '严格加密，安全可靠',
			cloud_storage_unavailable_line1: '该设备的云存储服务',
			cloud_storage_unavailable_line2: '暂不可用。',
			contact_administrator: '请联系管理员。',
			memory_card_recording: '开启内存卡录像',
			memory_card_type: '选择内存卡类型',
			internal_storage_space: '内部存储空间',
			storage_available: '可用{{value}}',
			storage_total: '总计{{value}}',
			format_memory_card: '格式化内存卡',
			storage_status_normal: '正常',
			memory_card_format_hint: '格式化后，部分内存卡空间将用于存储系统文件，显示的剩余容量可能小于内存卡实际容量。',
			memory_card_non_standard_tip: '提示：该内存卡为非标准卡。请使用标准卡以保障数据安全',
		},
		repair: {
			add_picture: '添加图片',
			fault_tip: '请描述故障现象和相关操作步骤，以便工程师尽快解决。',
			pictures_tip: '请上传相关图片供我们参考，以便高效解决问题。',
			record: '报修记录',
			date_range: '日期范围',
			status_submitted: '已提交',
			status_processing: '处理中',
			repair_no: '报修编号',
			select_store: '选择门店',
			contact_person: '联系人',
			contact_number: '联系电话',
			tel: '电话',
			store_prefix: '门店',
			fault_description: '故障描述',
			submission_time: '提交时间',
			images: '图片',
			no_images: '暂无图片',
		},
		snapshot: {
			timed_snapshot_inspection: '定时截图巡检',
			inspection_statistics: '巡检统计',
			inspection_data: '巡检数据',
			inspection_task: '巡检任务',
			create_inspection: '创建巡检',
			store_data_statistics: '门店数据统计',
			executor_statistics: '执行人统计',
			start_date: '开始日期',
			end_date: '结束日期',
			load_failed: '加载失败',
			apac_only: '定时截图巡检仅在海外版接入。',
			all_planned_screenshot: '全部计划抓图',
			current_screenshot: '当前抓图',
			current_processed: '当前已处理',
			overdue_unprocessed: '超期未处理',
			all_unprocessed: '全部未处理',
			maximum_violations: '最高违规数',
			minimum_violations: '最低违规数',
			account: '账号',
			full_name_role: '姓名（角色）',
			to_be_processed: '待处理',
			processed: '已处理',
			rank: '排名',
			task_status: '任务状态',
			enabled: '启用中',
			disabled: '已关闭',
			plan_opened_success: '计划开启成功',
			plan_closed_success: '计划关闭成功',
			plan_status_failed: '计划状态更新失败',
			delete_task: '删除任务',
			delete_success: '删除成功',
			delete_failed: '删除失败',
			today_screenshots: '今日抓图',
			today_processed: '今日已处理',
			total_unprocessed: '全部未处理',
			total_unqualified: '全部不合格',
			task_store: '任务门店',
			stores_suffix: '个门店',
			executor: '执行人',
			people_suffix: '人',
			task_time: '任务时间',
			execution_cycle: '执行周期',
			task_name: '任务名称',
			detail_information: '详细信息',
			execution_date: '执行日期',
			execution_month: '执行月份',
			assessment_template: '考核模板',
			select_template: '选择模板',
			store: '门店',
			select_executor: '选择执行人',
			device_point: '设备',
			select_device: '选择设备',
			execution_time: '执行时间',
			add_time: '添加时间',
			validation_template: '请选择考核模板',
			save_success: '保存成功',
			save_failed: '保存失败',
			qualified: '合格',
			unqualified: '不合格',
			process_success: '处理成功',
			process_failed: '处理失败',
			mon: '周一',
			tues: '周二',
			wed: '周三',
			thur: '周四',
			fri: '周五',
			sat: '周六',
			sun: '周日',
			ranking_all_stores: '全部门店排名',
			total_violations: '违规总数',
			ranking: '排名',
			violation_items_ranking: '违规项目排名',
			items_name: '项目名称',
			violation_numbers: '违规数量',
			percentage: '占比',
			daily_violation_item: '每日违规趋势（按违规项目）',
			daily_violation_store: '每日违规趋势（按门店）',
		},
		evaluation: {
			management: '管理',
			store: '门店',
			by_score: '按分数',
			by_store: '按门店',
			select_task: '选择任务',
			select_store: '选择门店',
			select_user: '选择用户',
			select_stores_count: '选择({{count}})门店',
			select_tasks_count: '选择({{count}})任务',
			search_store: '搜索门店',
			deselect_all: '取消全选',
			keyword_placeholder: '请输入关键词',
			user_keyword_placeholder: '请输入关键词...',
			expired_tasks: '过期任务',
			no_tasks_in_progress: '暂无进行中的任务',
			select_date: '选择日期',
			today: '今天',
			recent_7_days: '近 7 天',
			recent_30_days: '近 30 天',
			recent_90_days: '近 90 天',
			recent_180_days: '近 180 天',
			customize: '自定义',
			start_date: '开始日期',
			end_date: '结束日期',
			select_user_count: '选择({{count}})用户',
			select_templates_count: '选择({{count}})模板',
			please_select: '请选择',
			please_input: '请输入',
			please_input_keywords: '请输入关键词',
			store_name: '门店名称',
			name: '名称',
			select_all: '全选',
			location_permission: '需要开启定位权限以获取附近门店',
			reviewer: '审核人',
			submitter: '提交人',
			title: '考核',
			assessment_today: '今日考核',
			assigned_to_me: '分配给我',
			remote_assessment: '远程考核',
			onsite_assessment: '现场考核',
			my_task: '我的任务',
			ranking: '排名',
			task_progress: '任务进度：',
			report: '报告',
			my_assessment: '我的考核',
			audits: '审核',
			draft_box: '草稿箱',
			date: '日期',
			report_status: '报告状态',
			template: '模板',
			assessment_details: '考核详情',
			assessment_time: '考核时间',
			score: '分数',
			assessment_task: '考核任务',
			source: '来源',
			assessment_content: '考核内容',
			filter_full_score_item: '过滤满分项',
			standard: '标准',
			qualified: '合格',
			unqualified: '不合格',
			passed: '已通过',
			failed: '未通过',
			remarks: '备注',
			no_picture: '暂无图片',
			no: '无',
		},
		inspect: {
			empty: '您还没有添加门店巡检计划~',
			add_plan: '添加计划',
			title: '定时巡检',
			add_title: '新增计划',
			plan: '计划',
			plan_name: '计划名称',
			select_store: '选择门店',
			select_device: '选择设备',
			equipment_location: '设备点位',
			store_inspection_time: '门店巡检时间',
			set_time: '设置门店巡检时间',
			submit_plan: '提交计划',
			confirm: '确定',
			cancel: '取消',
			select_all: '全选',
			store_name: '门店名称',
			equipment_name: '设备名称',
			search_keywords: '请输入关键词',
			equipment_search: '设备搜索',
			no_stores: '暂无门店',
			no_devices: '暂无设备',
			store_count: '巡检门店数量',
			stores: '个门店',
			inspection_time: '门店巡检时间',
			running_state: '运行状态',
			executing: '执行中',
			closed: '已关闭',
			detail_title: '门店巡检计划详情',
			update_time: '更新时间',
			enabled: '已启用',
			off_state: '关闭状态',
			intelligent: '智能',
			time: '时间',
			no_data: '暂无数据',
			refresh: '刷新',
			plan_opened_success: '计划开启成功',
			plan_closed_success: '计划关闭成功',
			plan_status_failed: '计划状态更新失败',
			picture_preview: '图片预览',
			picture_load_failed: '图片加载失败',
			create_event: '创建事件',
			download_picture: '下载图片',
			intelligent_options: '智能选项',
			intelligent_options_title: '请选择门店巡检智能选项',
			intelligent_option_roughly: '此处大致符合要求',
			intelligent_options_learning: '了解更多智能选项...',
			intelligent_options_tip: '提示：开启智能选项后，不符合选项的门店巡检图片将单独列出。但如果摄像机发生偏移，结果可能不准确甚至无效。此时可以重新设置该点位的智能选项。',
			choose_later: '稍后选择',
			device_context_missing: '设备信息不可用',
			message_context_missing: '消息信息不可用',
			picture_unavailable: '图片不可用',
			add_success: '添加计划成功',
			delete: '删除',
			delete_confirm_title: '删除计划',
			delete_confirm_body: '确定删除该定时巡检计划？',
			delete_success: '计划已删除',
			delete_failed: '删除失败',
			load_failed: '定时巡检计划加载失败',
			submit_failed: '提交失败',
			validation_plan_name: '请输入计划名称',
			validation_store: '请选择门店',
			validation_device: '请选择设备',
			validation_time: '请选择巡检时间',
			validation_user: '缺少当前用户 ID',
			validation_item: '巡检项元数据不完整',
			hour: '时',
			minute: '分',
			time_slot_1: '请选择第一次门店巡检时间',
			time_slot_2: '请选择第二次门店巡检时间',
			time_slot_3: '请选择第三次门店巡检时间',
			time_slot_4: '请选择第四次门店巡检时间',
			time_slot_5: '请选择第五次门店巡检时间',
			time_slot_6: '请选择第六次门店巡检时间',
			time_slot_7: '请选择第七次门店巡检时间',
			time_slot_8: '请选择第八次门店巡检时间',
			time_slot_9: '请选择第九次门店巡检时间',
			time_slot_10: '请选择第十次门店巡检时间',
		},
	},
};
